'use strict';exports.__esModule = true;var _constants = require('../constants');
var _beautifyNumber = require('./beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var formatPropertyMinimumPrice = function formatPropertyMinimumPrice(_ref) {var locale = _ref.locale,isMobile = _ref.isMobile,translate = _ref.translate,minPrice = _ref.minPrice;
  var isDefaultLanguage = locale === _constants.language.default;
  var priceLocalizationKey = isMobile || !isDefaultLanguage ? 'from' : 'startingFrom';
  var separator = isMobile ? ' ' : ' - ';
  var nis = String.fromCharCode(8362);
  return '' + translate(
  priceLocalizationKey) +
  separator + nis + (0, _beautifyNumber2.default)(minPrice);
};exports.default =

formatPropertyMinimumPrice;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/formatPropertyPrice.js
// module id = 3067
// module chunks = 0